<template>
  <div class="role-page full-height">
    <table-con>
      <div slot="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/customers' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>用户等级</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div slot="search">
        <el-form :model="queryInfo" label-width="auto" size="small" class="search-form">
          <el-form-item label="用户等级：">
            <el-input v-model="queryInfo.userLevel" placeholder="等级名称" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button class="search-btn btn-gray" @click="handleReset">重置</el-button>
            <el-button class="search-btn btn-blue" @click="searchUserLevel">搜索</el-button>
            <el-button class="search-btn btn-green" @click="handleAdd">新增</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div slot="table" class="full-height display-col">
        <el-table
          :data="userLevelList"
          :header-cell-style="tableStyle.headerStyle"
          :cell-style="{ 'text-align': 'center' }"
          border
          ref="multipleTable"
          height="550"
        >
          <el-table-column type="index" label="序号" width="60"></el-table-column>
          <el-table-column label="操作" width="220">
            <template slot-scope="scope">
              <el-button size="mini" v-if="scope.row.userSize <= 0" class="search-btn btn-blue" @click="handleEdit(scope.row)">编辑</el-button>
              <el-button size="mini" v-if="scope.row.userSize <= 0" class="search-btn btn-red" @click="handleDel(scope.row.id)">删除</el-button>
              <el-button size="mini" class="search-btn btn-blue" @click="handleDetails(scope.row)">详情</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="userLevelName" label="用户等级"></el-table-column>
          <el-table-column prop="userSize" width="100" label="用户数量"></el-table-column>
          <el-table-column prop="openTime" label="启用时间" width="155"></el-table-column>
          <el-table-column prop="monthReduction" label="减免会员费期限" width="110"></el-table-column>
          <el-table-column prop="membershipFee" label="每月会员费（￥）" width="130">
            <template slot-scope="scope">
              {{ Number(scope.row.membershipFee).toLocaleString() }}
            </template>
          </el-table-column>
          <el-table-column prop="commission" width="160" label="代购手续费比率（%）"></el-table-column>
          <!--<el-table-column prop="rate" label="汇率附加比例"> </el-table-column>
          <el-table-column prop="creditLimit" label="会员信用额度（￥）">
            <template slot-scope="scope">
              {{ Number(scope.row.creditLimit).toLocaleString() }}
            </template>
          </el-table-column>-->
          <el-table-column prop="levelNote" label="等级说明" width="250">
            <template #default="{ row }">
              <el-tooltip effect="light" placement="top">
                <div class="zcl-tooltip-width" slot="content" v-html="row.levelNote">
                </div>
                <div class="strTwo">{{ row.levelNote }}</div>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryInfo.pageNum"
          :page-sizes="[5, 10, 20, 50, 100, 200]"
          :page-size="queryInfo.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </table-con>
    <!-- 新增/编辑 -->
    <el-dialog width="780px" title="用户等级配置" :visible.sync="visible" @close="handleCancel">
      <el-tabs v-model="activeName" type="card">
        <el-tab-pane label="基础配置" name="one">
          <el-form label-width="160px" label-position="right" :model="levelInfo" ref="levelFormRef" size="small" :rules="levelRules" class="level-form">
            <el-form-item label="用户等级名称" prop="userLevelName">
              <el-input :disabled="detailsVisible" v-model="levelInfo.userLevelName" placeholder="输入用户等级名称，如：战略合作"></el-input>
            </el-form-item>
            <el-form-item class="pos-r" label="减免会员费期限" prop="monthReduction">
              <el-popover
                placement="top-start"
                title="提示"
                width="530"
                trigger="hover"
                content="1、减免会员费期限设置0表示不减免，会员费次月1号凌晨自动扣当月会员费。2、设置1表示减免当月会员费，会员绑定后第三个月1号凌晨自动扣上月会员费。以此类推，最高减免12月。">
                <i class="el-icon-warning form-icon" slot="reference"></i>
              </el-popover>
              <el-input-number
                :disabled="detailsVisible"
                :controls="false"
                v-model="levelInfo.monthReduction"
                :min="0"
                :max="12"
                placeholder="输入0-12的数字，0代表不减免，最大减免12个月"
              ></el-input-number>
            </el-form-item>
            <el-form-item style="margin-bottom: 0;" label="每月会员费（￥）" prop="membershipFee">
              <el-input-number
                :disabled="detailsVisible"
                :controls="false"
                v-model="levelInfo.membershipFee"
                :precision="2"
                :step="0.1"
                :max="1000000"
                placeholder="输入每月会员费金额"
                @focus="showMembershipFee = true"
                @blur="showMembershipFee = false"
              ></el-input-number>
              <p v-if="showMembershipFee" style="font-size: 12px;color: #ff0000;line-height: 20px;">请输入数字，最大值为1000000</p>
              <p v-else style="height: 20px;"></p>
              <!--<p style="font-size: 12px;color: #ff0000;line-height: 20px;">请输入数字，最大值为1000000</p>-->
            </el-form-item>
            <el-form-item style="margin-bottom: 0;" label="代购手续费比率（%）" prop="commission">
              <el-input-number
                :disabled="detailsVisible"
                :controls="false"
                :max="100000"
                v-model="levelInfo.commission"
                placeholder="输入代购手续费比率"
                @focus="showCommission = true"
                @blur="showCommission = false"
              >
              </el-input-number>
              <p v-if="showCommission" style="font-size: 12px;color: #ff0000;line-height: 20px;">请输入数字</p>
              <p v-else style="height: 20px;"></p>
            </el-form-item>
            <el-form-item label="用户等级说明" prop="levelNote">
              <el-input :disabled="detailsVisible" type="textarea" :rows="3" resize="none" v-model="levelInfo.levelNote" placeholder="用户等级说明"></el-input>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="检品费配置" name="two">
          <el-table :header-cell-style="tableStyle.headerStyle"
                    :cell-style="tableStyle.cellStyle" :data="jpList" height="290">
            <el-table-column align="center" prop="name" label="名称" >
            </el-table-column>
            <el-table-column align="center" prop="newMoney" label="默认价格" >
              <template slot-scope="scope">
                {{ Number(scope.row.newMoney).toLocaleString() }}
              </template>
            </el-table-column>
            <el-table-column align="center" prop="data" label="会员价格" >
              <template slot-scope="scope">
                <el-input :disabled="detailsVisible" type="number" v-model='scope.row.data' style='width:120px '  size="small"/>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="国际运费配置" name="three">
          <el-table :header-cell-style="tableStyle.headerStyle"
                    :cell-style="tableStyle.cellStyle" :data="configList" height="290">
            <el-table-column width="250" align="center" type="weight" label="重量" >
              <template slot-scope="scope">
                <div>
                  <!-- <el-form-item  prop="endWeight"> -->
                  <span>
                    <el-input
                      type="number"
                      v-model="scope.row.startWeight"
                      style='width:80px;margin-right: 15px'
                      disabled
                      size="small"
                      prop="startWeight"
                    >
                    </el-input>&lt;a</span>
                  <span v-if="scope.row.sortFlag !=99" >
                    ≤
                    <el-input
                      type="number"
                      v-model='scope.row.endWeight'
                      style='width:80px ;margin-left: 15px'
                      size="small"
                      :disabled="detailsVisible"
                      @input='monitor(scope.row)'
                    />
                  </span>
                </div>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="chargingMethod" label="收费方式" >
              <template slot-scope="scope">
                <div>
                  <div v-if='scope.row.type==1'>固定值：<el-input :disabled="detailsVisible" type="number" v-model='scope.row.firstPrice' style='width:60px '  size="small"/></div>
                  <div v-if='scope.row.type==2'>
                    首重：<el-input :disabled="detailsVisible" type="number" v-model='scope.row.firstWeight' style='width:60px '  size="small"/>
                    首重价格：<el-input :disabled="detailsVisible" type="number" v-model='scope.row.firstPrice' style='width:60px '  size="small"/>
                    超过的单价：<el-input :disabled="detailsVisible" type="number" v-model='scope.row.excessPrice' style='width:60px '  size="small"/>/
                    <el-input :disabled="detailsVisible" type="number" v-model='scope.row.excessWeight' style='width:60px '  size="small"/></div>
                </div>
                <div v-if='scope.row.type==3'>单价：<el-input :disabled="detailsVisible" type="number" v-model='scope.row.firstPrice' style='width:60px ' size="small" />  </div>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="充值手续费配置" name="four">
          <div>
            <el-button :disabled="detailsVisible" class="search-btn btn-blue four-add" @click="handleFourAdd">新增</el-button>
            <el-button :disabled="detailsVisible" class="search-btn btn-blue four-add" @click="handleFourDel">重置手续费</el-button>
          </div>
          <el-table :header-cell-style="tableStyle.headerStyle"
                    :cell-style="tableStyle.cellStyle" :data="rechargeFeeLevels" height="290">
            <el-table-column align="center" type="weight" label="充值金额" >
              <template slot-scope="scope">
                <div>
                  <span>
                    <el-input
                      type="number"
                      v-model="scope.row.startRechargeFee"
                      style='width:180px;margin-right: 15px'
                      disabled
                      size="small"
                      prop="startWeight"
                    >
                    </el-input>&lt;a</span>
                  <span>
                    ≤
                    <el-input
                      type="number"
                      v-model='scope.row.endRechargeFee'
                      style='width:180px ;margin-left: 15px'
                      :disabled="detailsVisible || scope.$index < rechargeFeeLevels.length - 1"
                      size="small"
                      @blur='monitorFour(scope.row)'
                    />
                  </span>
                </div>
              </template>
            </el-table-column>
            <el-table-column width="250" align="center" prop="chargingMethod" label="手续费比例(%)" >
              <template slot-scope="scope">
                <el-input-number
                  :disabled="detailsVisible"
                  :min="0"
                  :max="100"
                  :controls="false"
                  v-model='scope.row.firstPrice'
                  style='width: 120px'
                  size="small"
                >
                </el-input-number>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
      <span v-if="!detailsVisible" slot="footer" class="dialog-footer">
        <el-button class="form-btn btn-gray" @click="handleCancel">取消</el-button>
        <el-button class="form-btn btn-blue" @click="handleSubmit">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import tableCon from "../../views/tableContainer";

export default {
  components: { tableCon },
  data() {
    return {
      queryInfo: {
        userLevel: "",
        pageSize: 10,
        pageNum: 1,
      },
      powerBtn: [],
      levelInfo: {
        userLevelName: "",
        levelNote: "",
        monthReduction: undefined,
        membershipFee: undefined,
        commission: undefined,
        rate: undefined,
        creditLimit: undefined,
      },
      levelRules: {
        userLevelName: [{ required: true, message: "用户等级名称为必填", trigger: "blur" }],
      },
      visible: false,
      isLoading: false,
      userLevelList: [],
      total: 0,
      submitUrl: "",
      activeName: 'one',
      configList: [],
      jpList: [],
      showMembershipFee: false,
      showCommission: false,
      detailsVisible: false,
      rechargeFeeLevels: [
        {
          startRechargeFee: 0,
          endRechargeFee: undefined,
          firstPrice: undefined,
        }
      ],
      endMoney: 0
    };
  },
  created() {
    /*let permissionList = JSON.parse(window.sessionStorage.getItem("permissionList"));
    let curPath = this.$router.history.current.path.slice(1);
    permissionList.map((item) => {
      if (item.menuUrl == curPath) {
        this.powerBtn = item.btnAuth;
      }
    });*/
    this.getUserLevelList();
  },
  watch: {
  },
  methods: {
    // 输入时 手续费
    monitorFour(val){
      if(parseFloat(val.endRechargeFee) <= parseFloat(this.endMoney)){
        val.endRechargeFee = undefined
        return this.$message({
          message: '金额结束区间范围不正确,请重新输入',
          type: 'warning'
        });
      }
    },
    // 新增
    handleFourAdd(){
      let obj = this.rechargeFeeLevels[this.rechargeFeeLevels.length - 1]
      if(!obj.endRechargeFee){
        return this.$message({
          message: '请输入配置金额结束区间',
          type: 'warning'
        });
      }
      if(!obj.firstPrice){
        return this.$message({
          message: '请输入手续费比例',
          type: 'warning'
        });
      }
      this.endMoney = obj.endRechargeFee
      let o = {
        startRechargeFee: obj.endRechargeFee,
        endRechargeFee: undefined,
        firstPrice: undefined,
      }
      this.rechargeFeeLevels.push(o)
    },
    // 重置手续费
    handleFourDel(){
      this.endMoney = 0
      this.rechargeFeeLevels = [
        {
          startRechargeFee: 0,
          endRechargeFee: undefined,
          firstPrice: undefined,
        }
      ]
    },
    // 检品费
    async getJpList() {
      const res = await this.$http.get("user/level/getSysCm");
      this.jpList = res.data.data.map(item=>{
        return{
          ...item,
          newMoney: item.data
        }
      });
    },
    // 国际运费
    async getConfigList() {
      const { data: res } = await this.$http.post("InternationalShippingConfig/getAllInternationalShippingConfig");
      this.configList = res.data;
    },
    //输入时 监控
    monitor(val){
      var index = this.configList.indexOf(val);
      this.configList[index+1].startWeight = val.endWeight
    },
    searchUserLevel() {
      this.queryInfo.pageNum = 1;
      this.queryInfo.pageSize = 10;
      this.getUserLevelList();
    },
    indexMethod(index) {
      return (this.pageNum - 1) * this.pageSize + index + 1;
    },
    handleSizeChange(pageSize) {
      this.queryInfo.pageSize = pageSize;
      this.getUserLevelList();
    },
    handleCurrentChange(pageNumber) {
      this.queryInfo.pageNum = pageNumber;
      this.getUserLevelList();
    },
    handleAdd() {
      this.getJpList();
      this.getConfigList();
      this.handleFourDel();
      this.visible = true;
      this.activeName = 'one'
      this.submitUrl = "user/level/saveAction";
      // this.submitUrl = "user/level/saveAction";
    },
    handleReset() {
      this.queryInfo.userLevel = "";
      this.searchUserLevel()
    },
    async getUserLevelList() {
      this.isLoading = true;
      const { data: res } = await this.$http.get("user/level/page", {
        params: this.queryInfo,
      });
      this.userLevelList = res.data.list;
      this.total = res.data.total;
      this.isLoading = false;
    },
    handleCancel() {
      const obj = this.levelInfo;
      const unNumberInfoKeyArr = ["userLevelName", "levelNote"];
      for (const key in obj) {
        if (Object.hasOwnProperty.call(obj, key)) {
          if (unNumberInfoKeyArr.includes(key)) {
            this.levelInfo[key] = "";
          } else {
            this.levelInfo[key] = undefined;
          }
        }
      }
      this.visible = false;
      this.detailsVisible = false;
    },
    handleSubmit() {
      console.log(this.rechargeFeeLevels)
      this.$refs.levelFormRef.validate((valid) => {
        if (!valid) {
          return false;
        }
        let params = {};
        const unNumberInfoKeyArr = ["userLevelName", "levelNote"];
        for (const key in this.levelInfo) {
          if (Object.hasOwnProperty.call(this.levelInfo, key)) {
            if (!unNumberInfoKeyArr.includes(key) && this.levelInfo[key] === undefined) {
              params[key] = 0;
            } else {
              params[key] = this.levelInfo[key];
            }
          }
        }
        params.cmNameLevels = this.jpList
        params.qytqcConfigWeightLevels = this.configList
        params.rechargeFeeLevelType = 3
        params.rechargeFeeLevels = this.rechargeFeeLevels.map((v,index)=>{
          if(index === this.rechargeFeeLevels.length - 1){
            v.endRechargeFee = undefined
          }
          if(!v.firstPrice){
            v.firstPrice = 0
          }
          return { ...v }
        })
        this.$confirm('此操作将立即生效, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$http
              .post(this.submitUrl, params)
              .then((res) => {
                if (res.data.code === 200) {
                  this.visible = false;
                  this.getUserLevelList();
                  this.$message.success(res.data.message);
                }
              })
              .catch((error) => {
                console.log('error',error)
                // this.$message.error(res.data.message);
              })
              .finally(()=>{
                this.visible = false;
                this.detailsVisible = false;
              })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消该操作'
          });
        });

      });
    },
    // 删除
    handleDel(id) {
      this.$confirm("是否确定删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$http
            .get("user/level/delete", {
              params: {
                id,
              },
            })
            .then((res) => {
              if (res.data.code == 200) {
                this.$message({
                  type: "success",
                  message: res.data.message,
                });
              } else {
                this.$message({
                  type: "error",
                  message: res.data.message,
                });
              }
              this.getUserLevelList();
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 编辑
    async handleEdit(row) {
      console.log(row)
      this.activeName = 'one'
      this.submitUrl = "user/level/updateAction";
      for (const key in row) {
        if (Object.hasOwnProperty.call(row, key)) {
          if (key in this.levelInfo) {
            this.levelInfo[key] = row[key];
          }
        }
      }
      this.levelInfo.id = row.id;
      this.configList = row.qytqcConfigWeightLevels
      this.rechargeFeeLevels = row.rechargeFeeLevels
      const res = await this.$http.get("user/level/getSysCm");
      this.jpList = row.cmNameLevels.map((item,index)=>{
        return{
          ...item,
          newMoney: res.data.data[index].data
        }
      });
      this.visible = true;
    },
    // 详情
    handleDetails(row){
      this.detailsVisible = true;
      this.handleEdit(row)
    },
  },
};
</script>

<style lang="less" scoped>
.role-page > .search-container {
  height: 60px !important;
}
.search-form {
  display: flex;
  justify-content: space-between;
  ::v-deep .el-form-item--small.el-form-item {
    margin-bottom: 0;
  }
}
.level-form {
  ::v-deep .el-input-number--small {
    width: 100%;
  }
  ::v-deep .el-input-number .el-input__inner {
    text-align: left
  }
}
.pos-r{
  position: relative;
  ::v-deep .el-form-item__label{
    padding-right: 30px!important;
  }
}
  .form-icon{
    cursor: pointer;
    position: absolute;
    top: 10px;
    left: -25px;
  }
::v-deep .el-tabs--card>.el-tabs__header .el-tabs__item.is-active {
  border-bottom-color: #E4E7ED;
}
.strTwo {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2; /* 设置最大显示行数 */
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
}
.zcl-tooltip-width{
  width: 400px;
}
  .four-add{
    float: right;
    margin-bottom: 15px;
  }
</style>
